<template>
  <v-container>
    <!-- Tabs navigation -->
    <v-tabs
      v-model="activeTab"
      align-tabs="center"
      color="deep-purple-accent-4"
    >
      <v-tab :value="0">Prochain envoi</v-tab>
      <v-tab :value="1">Hors conditions</v-tab>
    </v-tabs>

    <!-- Tab content with v-tabs-items -->
    <v-tabs-items v-model="activeTab">
      <!-- Tab 1: Prochain envoi -->
      <v-tab-item :value="0">
        <v-card outlined class="mt-5">
          <v-card-title>
            Liste des comptes à envoyer ({{
              accounts.pendingAccounts.length
            }})
            <v-spacer></v-spacer>
            <v-btn
              outlined
              small
              color="deep-purple-accent-4"
              :disabled="loading || downloading || !accounts.pendingAccounts.length"
              @click="downloadList('pending')"
            >
              <v-icon left>mdi-download</v-icon> Télécharger
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div v-if="loading" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <div class="mt-2">Chargement des données...</div>
            </div>

            <div
              v-else-if="accounts.pendingAccounts.length === 0"
              class="text-center pa-4"
            >
              Aucune donnée disponible
            </div>

            <v-simple-table v-else outlined>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>IDISA</th>
                    <th>Nom</th>
                    <th>Email École</th>
                    <th>Email Privé</th>
                    <th class="text-center">Template</th>
                    <th class="text-center">Condition</th>
                    <th>Création de compte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="account in accounts.pendingAccounts"
                    :key="account.id"
                    @click="showDetails(account)"
                    style="cursor: pointer"
                  >
                    <td>{{ account.idisa }}</td>
                    <td>{{ account.fullname }}</td>
                    <td>{{ account.student.emailEcole }}</td>
                    <td>{{ account.student.emailPrive }}</td>
                    <td class="text-center">
                      {{ account.template }}
                    </td>
                    <td class="text-center">
                      <v-icon>{{
                        `mdi-numeric-${account.code}-circle`
                      }}</v-icon>
                    </td>
                    <td>
                      {{
                        account.accountCreation
                          ? formatDate(account.accountCreation)
                          : "N/A"
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- Tab 2: Hors conditions -->
      <v-tab-item :value="1">
        <v-card outlined class="mt-5">
          <v-card-title>
            Liste des comptes hors conditions ({{
              accounts.outOfConditions.length
            }})
            <v-spacer></v-spacer>
            <v-btn
              outlined
              small
              color="deep-purple-accent-4"
              :disabled="loading || downloading || !accounts.outOfConditions.length"
              @click="downloadList('outOfConditions')"
            >
              <v-icon left>mdi-download</v-icon> Télécharger
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div v-if="loading" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <div class="mt-2">Chargement des données...</div>
            </div>

            <div
              v-else-if="accounts.outOfConditions.length === 0"
              class="text-center pa-4"
            >
              Aucune donnée disponible
            </div>

            <v-simple-table v-else>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nom</th>
                    <th>Création de compte</th>
                    <th>Raisons</th>
                    <th class="text-center">Condition</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="account in accounts.outOfConditions"
                    :key="account.id"
                    @click="showDetails(account)"
                    style="cursor: pointer"
                  >
                    <td>{{ account.idisa }}</td>
                    <td>{{ account.fullname }}</td>
                    <td>
                      {{
                        account.accountCreation
                          ? formatDate(account.accountCreation)
                          : "N/A"
                      }}
                    </td>
                    <td>
                      <ul>
                        <li
                          v-for="(label, i) in account.reasonsLabels"
                          :key="account._id + i"
                        >
                          {{ label }}
                        </li>
                      </ul>
                    </td>
                    <td class="text-center">
                      <v-icon>{{
                        `mdi-numeric-${account.code}-circle`
                      }}</v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <!-- Simplified dialog -->
    <v-dialog v-model="detailsDialog" max-width="500">
      <v-card v-if="selectedAccount">
        <v-card-title>
          Détails du compte
          <v-spacer></v-spacer>
          <v-btn icon @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p><strong>IDISA:</strong> {{ selectedAccount.idisa }}</p>
          <p><strong>Nom:</strong> {{ selectedAccount.fullname }}</p>
          <p>
            <strong>Username:</strong> {{ selectedAccount.student.username }}
          </p>
          <p><strong>Mot de passe:</strong> {{ selectedAccount.password }}</p>
          <p><strong>Email École:</strong> {{ selectedAccount.student.emailEcole }}</p>
          <p><strong>Email Privé:</strong> {{ selectedAccount.student.emailPrive }}</p>
          <p>
            <strong>Création de compte:</strong>
            {{
              selectedAccount.accountCreation
                ? formatDate(selectedAccount.accountCreation)
                : "N/A"
            }}
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Simple snackbar -->
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top>
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { format, parseISO } from "date-fns";
import fileDownload from "js-file-download";

export default {
  name: "Pending",
  data() {
    return {
      activeTab: 0,
      accounts: { pendingAccounts: [], outOfConditions: [] },
      loading: false,
      downloading: false,
      selectedAccount: null,
      detailsDialog: false,
      snackbar: {
        visible: false,
        text: "",
        color: "info",
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URI}/admin/notifications`,
          {
            params: {
              type: "pending",
            },
          }
        );

        if (response.data) {
          this.accounts = response.data;
        } else {
          this.accounts = [];
          this.showMessage("Format de données inattendu", "warning");
        }
      } catch (error) {
        this.accounts = [];
        this.showMessage("Erreur lors du chargement des données", "error");
        console.error("Erreur API:", error);
      } finally {
        this.loading = false;
      }
    },

    showDetails(account) {
      this.selectedAccount = account;
      this.detailsDialog = true;
    },

    async downloadList(list) {
      this.downloading = true;
      try {
        const { data } = await axios({
          method: "get",
          url: `${process.env.VUE_APP_API_URI}/admin/notifications`,
          params: { type: "pending", format: "xlsx", list },
          responseType: "arraybuffer",
        });
        const filename =
          list === "outOfConditions"
            ? "hors-conditions.xlsx"
            : "prochain-envoi.xlsx";
        fileDownload(data, filename);
      } catch (error) {
        this.showMessage("Erreur lors de l'export", "error");
        console.error("Erreur export:", error);
      } finally {
        this.downloading = false;
      }
    },

    showMessage(text, color = "info") {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },

    formatDate(date) {
      return format(parseISO(date), "dd.MM.yyyy HH:mm:ss");
    },
  },
};
</script>